import React, { useEffect, useState } from "react";
import AuthUser from "../../../backend/pages/AuthUser";
import LoginForm from "../../../backend/pages/LoginForm";

export const Step4 = ({
  firstname,
  setFirstname,
  lastname,
  setLastname,
  email,
  setEmail,
  phoneNumber,
  setPhoneNumber,
  pin,
  setPin,
}) => {
  const { user } = AuthUser();

  // {"id":"1","firstname":"matteo","lastname":"maggioni","competence_id":"4","fiscalcode":"MGGMTT94R31D4","email":"matteomaggioni94@gmail.com","created":"2023-01-19 16:10:16","updated":"2023-06-23 17:01:29"}
  return (
    <div className={"row mt-5"}>
      <div className="it-page-sections-container">
        <section className="it-page-section" id="applicant">
          <div className=" bg-gray-100 shadow-sm">
            <LoginForm
              registrazioneProp={true}
              firstname={firstname}
              setFirstname={setFirstname}
              lastname={lastname}
              setLastname={setLastname}
              email={email}
              setEmail={setEmail}
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
              pin={pin}
              setPin={setPin}
            />
          </div>
        </section>
      </div>
    </div>
  );
};

{
  /*     <div className="it-page-sections-container">
        <section className="it-page-section" id="applicant">
          <div className="cmp-card">
            <div className="card has-bkg-grey shadow-sm p-big">
              <div className="card-header border-0 p-0 mb-lg-30">
                <div className="d-flex">
                  <h2 className="title-xxlarge mb-1">Richiedente</h2>
                </div>
                <p className="subtitle-small mb-0"> di te</p>
              </div>
              <div className="card-body p-0">
                <div className="cmp-info-button-card">
                  <div className="card p-3 p-lg-4">
                    <div className="card-body p-0">
                      <h3 className="big-title mb-0">
                        <span className="text-capitalize">
                          {user.firstname} {user.lastname}
                        </span>
                      </h3>

                      <p className="card-info">
                        Codice Fiscale <br />
                        <span>{user.fiscalcode}</span>
                      </p>
                      <p className="card-info">
                        Email <br />
                        <span>{user.email}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> */
}
